import React from "react";

import { Box, Text, Title } from "./styles";

interface EmptyStateProps {
    title?: React.ReactNode;
    description?: React.ReactNode;
    // Кнопка-действие под текстом: «Добавить набор», «Добавить столы».
    action?: React.ReactNode;
    className?: string;
}

export const EmptyState = ({ title, description, action, className }: EmptyStateProps) => (
    <Box className={className}>
        {title && <Title>{title}</Title>}
        {description && <Text>{description}</Text>}
        {action}
    </Box>
);
